import { isEmpty } from '@Util/stringUtils';
import { useEffect } from 'react';
import { useTskContext } from './useTskContext';

export function usePageTitle(pageName: string) {
    const { companyName } = useTskContext();

    const elements = [companyName, pageName, 'Tripletex'];
    const title = elements.filter((e) => !isEmpty(e)).join(' - ');

    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;

        return () => {
            document.title = previousTitle;
        };
    }, [title]);
}
